Dom.addComponent(new class TopbarComponent extends AbstractComponent {

  constructor() {
    super({
      name: "topbar",
      iframable: true,
      responsiveChildren: {
        width: false,
        height: true
      }
    });
  }

  css() {
    return `GULP-CSS-FILE-TOPBAR`;
  }

  html(props) {
    return `
      <div class="slaask-hidden">
        <div id="slaask-topbar-close-button" class="slaask-topbar-close-button">
          ${Svg.cross(this.app._title_color, 26)}
        </div>
        <div class="slaask-topbar-content">
          <div id="slaask-topbar-text" class="slaask-topbar-text">
            We just launched an amazing new product!
          </div>
          <div class="slaask-topbar-form" id="slaask-topbar-form">
            <button id="slaask-topbar-button" class="slaask-topbar-button">
              Take me there
            </button>
          </div>
        </div>
      </div>
    `;
  }

});
